import { post, upload, destroy } from 'app/shared/utils/fetchr';

// Models
import { CreateSarPayload } from 'app/modules/fincenSAR/requests';

// Actions
import { archiveSar as archiveSarAction } from 'app/modules/fincenSarOld/actions';

// Routes
import routes from 'app/shared/utils/routes';
import { GoAMLAttachments } from 'app/modules/goAML/models';

export const createSar = (
  payload: CreateSarPayload,
  useCacheEndpoint: boolean = false,
) => {
  if (useCacheEndpoint) {
    return post('/sars/cached/create', payload);
  }
  return post('/sars/create', payload);
};

export const archiveSar = (
  payload: ReturnType<typeof archiveSarAction>['payload'],
) => {
  return post(routes.patronus.sarsArchive, payload);
};

export const addGoAMLAttachments = (payload: GoAMLAttachments) => {
  const { id, files } = payload;
  const path = routes.patronus.goAMLIdAttachment.replace(':id', `${id}`);

  const formData = new FormData();
  files.forEach((file, idx) => formData.append(`file${idx}`, file));

  return upload(path, formData);
};

export const deleteGoAMLAttachment = (sarId: number, attachmentId: number) => {
  const path = routes.patronus.goAMLIdAttachmentAttachmentId
    .replace(':id', `${sarId}`)
    .replace(':attachmentId', `${attachmentId}`);
  return destroy(path);
};
